// extracted by mini-css-extract-plugin
export var sectionCta = "gg_kj";
export var inpEmail = "gg_lj";
export var inpButton = "gg_mj";
export var textDescription = "gg_nj";